/**
 * This component is intended to reflect the high level structure of your application,
 * and render any components that are common across all views, such as the header or
 * top-level navigation. All other components should be rendered by route handlers.
 **/

var React = require('react');
var mui = require('material-ui');
var Header = require('./Header');
var Server = require('./Server');
var Ports = require('./Ports');
var PayloadStates = require('../constants/PayloadStates');
var SuccessDialog = require('../dialogs/Success');
var FailureDialog = require('../dialogs/Failure');
var SetupFailureDialog = require('../dialogs/SetupFailure');

module.exports = React.createClass({
  displayName: 'Layout',

  getInitialState: function() {
    return {
      hasStarted: false,
      server: null,
      isTesting: false,
      ports: null,
      isComplete: false
    }
  },

  // componentDidMount: function() {
  //   var ports = {
  //     state: 'RESOLVED',
  //     data: [
  //       {
  //         id: 20000,
  //         state: 'RESOLVED'
  //       },
  //       {
  //         id: 20001,
  //         state: 'ERROR_FETCHING'
  //       },
  //       {
  //         id: 20002,
  //         state: 'ERROR_FETCHING'
  //       }
  //     ]
  //   };
  //
  //   lore.dialog.show(function() {
  //     return (
  //       <SuccessDialog />
  //     );
  //   });
  //
  //   lore.dialog.show(function() {
  //     return (
  //       <FailureDialog ports={ports} />
  //     );
  //   });
  // },

  onFetchSchema: function() {
    var server = lore.actions.server.get(1247).payload;

    this.setState({
      hasStarted: true,
      isTesting: false,
      isComplete: false,
      server: server
    });
  },

  onSetupComplete: function(server, failed) {
    if (failed > 0) {
      lore.dialog.show(function() {
        return (
          <SetupFailureDialog server={server} />
        )
      });
    } else {
      this.onBeginTest(server);
    }
  },

  onBeginTest: function(server) {
    var ports = lore.actions.port.test(server).payload;

    this.setState({
      isTesting: true,
      server: server,
      ports: ports
    })
  },

  onTestComplete: function(ports, failed) {
    if (failed > 0) {
      lore.dialog.show(function() {
        return (
          <FailureDialog ports={ports} />
        )
      });
    } else {
      lore.dialog.show(function() {
        return (
          <SuccessDialog />
        )
      });
    }

    this.setState({
      hasStarted: true,
      isTesting: true,
      isComplete: true
    });
  },

  render: function() {
    var hasStarted = this.state.hasStarted;
    var isTesting = this.state.isTesting;
    var isComplete = this.state.isComplete;
    var server = this.state.server;
    var ports = this.state.ports;

    var buttonLabel = isTesting ? 'Running test...' : 'Begin Test';

    if (isComplete) {
      buttonLabel = 'Retry Test';
    }

    return (
      <div>
        <Header/>
        <div className="container layout-container">
          <div className="col-md-offset-2 col-md-8 layout-container-col">
            <h3 className="layout-text">
              This page will perform a series of short network connections between your system and a
              CyVerse server to determine if there might be potential connectivity issues to the CyVerse
              Data Store.
            </h3>
            <h3 className="layout-text">
              These tests will only identify if a connection problem exists, but will not necessarily
              identify the source of the problem or if there might be a transient connectivity issue.
            </h3>
            <h3 className="layout-text">
              When you're ready to begin the test, press the button below.
            </h3>
          </div>
        </div>
        <div className="container">
          <div className="col-md-offset-2 col-md-8 start-button-col">
            <mui.RaisedButton
              label={buttonLabel}
              primary={true}
              disabled={isTesting && !isComplete}
              onTouchTap={this.onFetchSchema} />
          </div>
        </div>
        <div className="container margin-top">
          <div className="col-md-offset-2 col-md-8">
            {hasStarted ? (
                <Server
                  isTesting={isTesting}
                  onTestComplete={this.onSetupComplete} />
              ) : null
            }
          </div>
        </div>
        <div className="container margin-top">
          <div className="col-md-offset-2 col-md-8">
            {isTesting ? (
              <Ports
                isTesting={isTesting}
                onTestComplete={this.onTestComplete} />
              ) : null
            }
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/components/Layout.js